"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quill = exports.QuillDeltaApi = exports.QuillDeltaNode = void 0;
const constants_1 = require("../constants");
const QuillDeltaNode_1 = require("./QuillDeltaNode");
Object.defineProperty(exports, "QuillDeltaNode", { enumerable: true, get: function () { return QuillDeltaNode_1.QuillDeltaNode; } });
const QuillDeltaApi_1 = require("./QuillDeltaApi");
Object.defineProperty(exports, "QuillDeltaApi", { enumerable: true, get: function () { return QuillDeltaApi_1.QuillDeltaApi; } });
const constants_2 = require("./constants");
const Extension_1 = require("../../json-crdt/extensions/Extension");
const constants_3 = require("../peritext/constants");
exports.quill = new Extension_1.Extension(constants_1.ExtensionId.quill, constants_2.MNEMONIC, QuillDeltaNode_1.QuillDeltaNode, QuillDeltaApi_1.QuillDeltaApi, (text) => (0, constants_3.SCHEMA)(text));
